<app-dialog-base [showLoadingSpinner]="showLoadingSpinner">
  <span dialog-title>Sent Email</span>

  <ng-container dialog-content>
    @if (emailAudit) {
      <div class="flex-row-wrap justify-start gap-normal margin-bottom-med margin-top-med">
        <div class="detail-section">
          <div class="detail-label">Kind</div>
          <div class="detail-value" data-testid="email-audit-kind">{{ emailAudit.EmailTemplateTypeName }}</div>
        </div>

        <div class="detail-section">
          <div class="detail-label">To</div>
          <div class="detail-value" data-testid="email-audit-recipient">
            {{ emailAudit.Recipient }}@if (emailAudit.IsBcc) { (BCC)}@if (emailAudit.Excluded) { (excluded)}
          </div>
        </div>

        <div class="detail-section">
          <div class="detail-label">From</div>
          <div class="detail-value">{{ emailAudit.Sender }}</div>
        </div>

        <div class="detail-section">
          <div class="detail-label">Subject</div>
          <div class="detail-value" data-testid="email-audit-subject">{{ emailAudit.Subject }}</div>
        </div>

        <div class="detail-section">
          <div class="detail-label">Status</div>
          <div class="detail-value" data-testid="email-audit-status">
            {{ emailAudit.EmailAuditStatusName }}@if (emailAudit.ResponseStatusCode) { ({{ emailAudit.ResponseStatusCode }})}
          </div>
        </div>

        <div class="detail-section">
          <div class="detail-label">Created On</div>
          <div class="detail-value">{{ emailAudit.CreatedOn | date: 'medium' }}</div>
        </div>

        @if (emailAudit.ScheduledFor) {
          <div class="detail-section">
            <div class="detail-label">Scheduled For</div>
            <div class="detail-value">{{ emailAudit.ScheduledFor | date: 'medium' }}</div>
          </div>
        }

        @if (emailAudit.CompletedOn) {
          <div class="detail-section">
            <div class="detail-label">Completed On</div>
            <div class="detail-value">{{ emailAudit.CompletedOn | date: 'medium' }}</div>
          </div>
        }

        <div class="detail-section">
          <div class="detail-label">Game</div>
          <div class="detail-value">{{ emailAudit.GameName ?? 'No game' }}</div>
        </div>

        <div class="detail-section">
          <div class="detail-label">SendGrid Template</div>
          <div class="detail-value">{{ emailAudit.SendGridTemplateId }}</div>
        </div>
      </div>

      @if (emailAudit.Error) {
        <h4>Error</h4>
        <pre class="email-audit-error" data-testid="email-audit-error">{{ emailAudit.Error }}</pre>
      }

      @if (!templateData) {
        <p class="margin-top-med" data-testid="email-audit-no-data">
          The email's content was not stored, either because this kind of email can contain a secret, or because it has
          passed the data retention period.
        </p>
      } @else {
        @if (isRedirectEmail) {
          <h4>Message</h4>
          <div class="email-audit-message" data-testid="email-audit-message">
            <p class="detail-label">{{ templateData.Subject }}</p>
            <!-- Angular sanitizes bound HTML, so script and event attributes in the content are stripped. -->
            <div [innerHTML]="templateData.Content"></div>
            @if (templateData.CallToAction) {
              <p><strong>{{ templateData.CallToAction }}</strong></p>
            }
          </div>
        }

        <h4>Template Data</h4>
        <pre data-testid="email-audit-template-data"><app-formatter [data]="templateData"></app-formatter></pre>
      }
    }
  </ng-container>
  <ng-container actions></ng-container>
</app-dialog-base>
